import { render, staticRenderFns } from "./ButtonDeleteUpload.vue?vue&type=template&id=6b7d5b5c&scoped=true"
import script from "./ButtonDeleteUpload.vue?vue&type=script&lang=js"
export * from "./ButtonDeleteUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7d5b5c",
  null
  
)

export default component.exports